import http from '@/axios/http'

// 查询日志
export function getLogList(data) {
    return http({
        url: '/api/operation-log/queryGroupKeyword',
        method: 'post',
        data
    })
}

// 查看日志详情
export function getLogDetail(id) {
    return http({
        url: '/api/operation-log/detail/' + id,
        method: 'get',
    })
}